import { useQuery } from 'react-query'

import { apiFetch } from 'lib/action-helpers'
import { onboardingPaths as paths, ONBOARDING } from './index'
import { useOrganization } from 'hooks/context/organization-context'

const getOnboarder = async (organization, delegation) => {
  const data = await apiFetch(paths.onboarding(organization, delegation))
  return data
}

export const useOnboarderQuery = ({ delegation }) => {
  const { organization } = useOrganization()

  return useQuery(
    [ONBOARDING, organization?.id],
    () => getOnboarder(organization.id, delegation),
    {
      staleTime: Infinity,
      enabled: !!organization?.id && !!delegation,
      refetchOnWindowFocus: false,
      retry: false
    }
  )
}
